import { useContext, useEffect, useState } from "react";
import {
  ErrorMessage,
  Input,
  Select,
  Textarea,
} from "../components/styledComponent/formInputs";
// import profile from "../assets/images/svg/Profile.svg";
import Button from "../common/Button";
import { Context } from "../context/MainContext";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import { userDetailsUpdateSuccess } from "../context/Action";
import { updateProfile } from "../api/usersApi";

const Profile = () => {
  const [edit, setEdit] = useState(false);
  const { user, dispatch } = useContext(Context);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [inputError, setInputError] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let firstNameError = "";
    let lastNameError = "";
    let emailError = "";

    if (!firstName) {
      firstNameError = "first name is required";
    }
    if (!lastName) {
      lastNameError = "last name is required";
    }
    if (!email) {
      emailError = "email is required";
    }
    if (!email.includes("@")) {
      emailError = "email is invalid";
    }

    if (emailError || lastNameError || firstNameError) {
      setInputError((curr) => {
        return {
          ...curr,
          email: emailError,
          lastName: lastNameError,
          firstName: firstNameError,
        };
      });
      return false;
    }
    return true;
  };

  const handleEditProfile = async () => {
    const checkValidate = validate();
    if (checkValidate) {
      // if(usser)
      setInputError({});
      setLoading(true);
      try {
        let data = {
          email,
          firstName,
          lastName,
        };

        await updateProfile(data, user?.id, user?.accessToken);

        setLoading(false);
        toast.success("Profile update successfully");
        const newUser = {
          id: user?.id,
          role: user?.role,
          accessToken: user?.accessToken,
          email,
          firstName,
          lastName,
        };
        dispatch(userDetailsUpdateSuccess(newUser));
        setEdit(false);
      } catch (err) {
        setLoading(false);
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        toast.error(message);
      }
    }
  };

  useEffect(() => {
    if (user?.id) {
      setFirstName(user?.firstName);
      setLastName(user?.lastName);
      setEmail(user?.email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  return (
    <div className="profile">
      <div className="profile__main">
        <h2
          className={
            edit ? "profile__main__title active" : "profile__main__title"
          }
        >
          ABOUT ME
          <i
            onClick={() => setEdit((curr) => !curr)}
            className="bx bx-edit"
          ></i>
        </h2>

        <div className="profile__main__con">
          <div className="profile__main__info">
            <div className="profile__main__info__item">
              <b>First Name</b>

              {!edit ? (
                <span>{user?.firstName}</span>
              ) : (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Input
                    width="250px"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  <ErrorMessage>{inputError?.firstName}</ErrorMessage>
                </div>
              )}
            </div>
            <div className="profile__main__info__item">
              <b>Last Name</b>

              {!edit ? (
                <span>{user?.lastName}</span>
              ) : (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Input
                    width="250px"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                  <ErrorMessage>{inputError?.lastName}</ErrorMessage>
                </div>
              )}
            </div>

            <div className="profile__main__info__item">
              <b>Email</b>

              {!edit ? (
                <span>{user?.email}</span>
              ) : (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Input
                    width="250px"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <ErrorMessage>{inputError?.email}</ErrorMessage>
                </div>
              )}
            </div>
          </div>
        </div>

        {edit && (
          <div className="profile__main__btn">
            <button className="btn" height="40px" onClick={handleEditProfile}>
              {loading ? <Loading button={true} /> : "Save"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
